import React, { useState  , useEffect} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";

import { fetchOptionListData } from "@/slices/LocationSlice/optionSlice";
import {
  fetchVariableList,
  updateVariableList,
} from "@/slices/panelSlice/variableListSlice";


function SingleAddOptionList({ currOptions, Close , currId}) {
  const dispatch = useDispatch();
  const { optionList } = useSelector((state) => state.option);

    useEffect(() => {
      dispatch(fetchOptionListData());
    }, [dispatch]);

    
  // ✅ Start with one row already visible
  const [newOptions, setNewOptions] = useState([
    { title: "", val: "", optionType: "" },
  ]);

  const [errorMessage, setErrorMessage] = useState("");

  // ➕ Add row
  const addNewRow = () => {
    setNewOptions([
      ...newOptions,
      { title: "", val: "", optionType: "" },
    ]);
  };

  // ✏️ Handle change
  const handleChange = (index, field, value) => {
    const updated = [...newOptions];
    updated[index][field] = value;
    setNewOptions(updated);
    setErrorMessage("");
  };

  // ❌ Delete row
  const handleDeleteRow = (index) => {
    const updated = newOptions.filter((_, i) => i !== index);

    // 👉 Always keep at least 1 row
    setNewOptions(
      updated.length > 0
        ? updated
        : [{ title: "", val: "", optionType: "" }]
    );
  };

  // 💾 Save
  const handleSave = async () => {
    const isInvalid = newOptions.some(
      (opt) => !opt.title || !opt.val || !opt.optionType
    );

    if (isInvalid) {
      setErrorMessage("Please fill all fields");
      return;
    }

    const finalData = newOptions.map((opt) => ({
      ...opt,
      translate: {
        English: opt.title,
      },
    }));


     const payload = {
      id: currId,
      option_List: finalData,
    };
      
    await dispatch(updateVariableList(payload));
    await dispatch(fetchVariableList());
    Close()
  };

  return (
    <div className="py-6 px-4">

      {/* 🧾 Inputs */}
      {newOptions.map((opt, index) => (
        <div key={index} className="flex gap-2 mb-2 items-center">

          {/* Title */}
          <input
            type="text"
            placeholder="Title"
            value={opt.title}
            onChange={(e) =>
              handleChange(index, "title", e.target.value)
            }
            className="p-1 border rounded text-xs"
          />

          {/* Value */}
          <input
            type="number"
            placeholder="Value"
            value={opt.val}
            onChange={(e) =>
              handleChange(index, "val", e.target.value)
            }
            className="p-1 border rounded text-xs"
          />

          {/* Option Type */}
          <select
            value={opt.optionType}
            onChange={(e) =>
              handleChange(index, "optionType", e.target.value)
            }
            className="p-1 border rounded text-xs"
          >
            <option value="">Select Type</option>
            {optionList?.result?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.title}
              </option>
            ))}
          </select>

          {/* ❌ Delete */}
          <button
            onClick={() => handleDeleteRow(index)}
            className="px-2 bg-red-500 text-white rounded"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>

          {/* ➕ Add more */}
          {index === newOptions.length - 1 && (
            <button
              onClick={addNewRow}
              className="px-2 bg-[var(--mainCol)] text-white rounded"
            >
              <FontAwesomeIcon icon={faPlus} />
            </button>
          )}
        </div>
      ))}

      {/* ❗ Error */}
      {errorMessage && (
        <div className="text-red-500 text-sm mb-2">
          {errorMessage}
        </div>
      )}

      {/* 💾 Save */}
      <button
        onClick={handleSave}
        className="px-4 py-1 bg-green-600 text-white rounded text-sm mt-2"
      >
        Save Options
      </button>

    </div>
  );
}

export default SingleAddOptionList;